import React from 'react';
import { Flex } from '@chakra-ui/react';
import HomeTitleSection from '../organism/HomeTitleSection';
import HomeNavigationSection from '../organism/HomeNavigationSection';
import useWindowDimensions from '../../../hooks/windowDimensions';

const HomeTemplate: React.FC = () => {
  const dimensions = useWindowDimensions();
  return (
    <Flex align='center' direction='column' minH={dimensions.height} color='secondary'>
      <HomeTitleSection flex='1 0' />
      <HomeNavigationSection flex='0 1' />
    </Flex>
  );
};

export default HomeTemplate;
